<template>
  <FocusLoop>
    <!-- eslint-disable-next-line vuejs-accessibility/no-static-element-interactions -->
    <div class="c-modal__backdrop" @click="close" @keyup="closeOnEscape">
      <div class="container">
        <div class="c-modal__row">
          <div class="c-modal__cols" :class="`c-modal__cols--${size}`">
            <div class="c-modal" :class="[className]" tabindex="-1">
              <header class="c-modal__header" @click.stop>
                <slot name="header" />
                <button v-if="!hideCloseButton" class="btn-close" :aria-label="$t('ARIA.CLOSE_MODAL')" @click="close">
                  <CloseIcon class="icon" />
                </button>
              </header>
              <div class="c-modal__header-triangle"></div>
              <section class="c-modal__body" @click.stop>
                <slot name="body"></slot>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </FocusLoop>
</template>

<script lang="ts" setup>
import useModal from '@/services/useModal';
import { onEscape } from '@/utils/keyboard';
import CloseIcon from '@/assets/icons/CloseIcon.vue';
import FocusLoop from '@/components/focus-loop/FocusLoop.vue';

interface ModalLayoutProps {
  size?: string;
  className?: string;
  hideCloseButton?: boolean;
}

withDefaults(defineProps<ModalLayoutProps>(), {
  size: 'lg',
  hideCloseButton: false,
});

const { close } = useModal();
const closeOnEscape = (event: KeyboardEvent) => {
  onEscape(close)(event);
};
</script>
